import { Button } from '@breetometer/components';
import { CurrencyBalance } from 'BreetAssets';
import { TransactionDetails } from 'BreetComponents';

import type { IFiatTransactionDetailsViewProps } from './FiatTransactionDetails.helpers';

const FiatTransactionDetailsView = ({
	amount,
	expectedFiat,
	handleVerification,
	symbol,
	balance,
	isLoading,
	rate,
}: IFiatTransactionDetailsViewProps) => (
	<div className='transaction-details payment-request-form_usdDestination'>
		<TransactionDetails.Content>
			<TransactionDetails.Row
				label='Amount'
				value={`${symbol}${amount}`}
			/>

			<TransactionDetails.Row
				label='Current Rate'
				value={rate}
			/>

			<TransactionDetails.Row
				label={`Expected ${expectedFiat.currencyCode} Equivalent`}
				value={expectedFiat.amount}
			/>
		</TransactionDetails.Content>

		<CurrencyBalance
			variant={balance.currencyCode}
			balance={balance.amount}
			className='svg-dark svg-dark-outline'
		/>

		<Button
			label='Withdraw'
			className='right-sheet_cta_fullwidth'
			type='button'
			onClick={handleVerification}
			isLoading={isLoading}
		/>
	</div>
);

export default FiatTransactionDetailsView;
